// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2c102576","726":"63e59fed","732":"b6c9d95e","977":"ef30fda0"}[chunkId] + ".chunk.js";
};